import ErrorLogger from '../infrastructure/error-logger';

export default class AjaxCall {

    static call(options) {
        try {
            const isPost = options.method === 'POST';

            if (options.isAsync === undefined || options.isAsync === null
                || !options.url || !options.method || (isPost && !options.requestData)) {
                AjaxCall._ignoreSensitiveData(options);
                throw new Error(`JLS Missing AjaxCall.call preconditions; Options: ${JSON.stringify(options)}`);
            }

            return fetch(options.url, {
                credentials: 'include', // Send cookies of CORS request; Needed for GateKeeper to know AnonymousId;
                method: options.method,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: isPost ? JSON.stringify(options.requestData) : undefined

            }).catch((exception) => {
                // The catch order is intentional. Catch only fetch network errors
                if (options.isAsync) {
                    return new Promise((resolve) => {
                        try {
                            AjaxCall._throwError(`JLS Network error occurred: ${options.url} ${options.method}`);
                        } catch (ex) {
                            AjaxCall._logError(ex, options);
                        }

                        resolve();
                    });
                }

                AjaxCall._throwError('JLS Network error occurred', options, null, exception);

            }).then((response) => {
                if (!response) {
                    return new Promise((resolve) => resolve());
                }

                try {
                    if (options.isAsync) {
                        try {
                            return AjaxCall._getResponseDataAsync(options, response, false);
                        } catch (ex) {
                            AjaxCall._logError(ex, options, response);
                        }

                        return new Promise((resolve) => resolve());
                    }

                    return AjaxCall._getResponseDataAsync(options, response, true);
                } catch (ex) {
                    AjaxCall._logError(ex, options, response);
                    AjaxCall._throwError('JLS Ajax call failed', options, response);
                }
            })
        }
        catch (ex) {
            ErrorLogger.log(ex);
            throw ex;
        }
    }

    static _getResponseDataAsync(options, response, resolveResponse) {
        if (200 <= response.status && response.status <= 299) {
            return new Promise((resolve) => resolve(resolveResponse ? response.json() : undefined));
        } else {
            AjaxCall._throwError(`JLS Ajax call failed: ${options.url} ${options.method}`);
        }
    }

    static _logError(ex, options, response) {
        if(response && response.body && !response.bodyUsed) {
            response.text().then((responseData) => {
                AjaxCall._callErrorLogger(ex, options, response.status, responseData);
            });
        } else {
            AjaxCall._callErrorLogger(ex, options, response && response.status, '');
        }
    }

    static _callErrorLogger(ex, requestOptions, responseStatus, responseData) {
        ErrorLogger.log(ex, {
            ajax: {
                requestOptions: requestOptions,
                responseStatus: responseStatus,
                responseData: responseData
            }
        });
    }

    static _throwError(message, options, response, exception) {
        if (options) {
            AjaxCall._ignoreSensitiveData(options);
        }

        var errorTextParts = [];

        errorTextParts.push(message);
        errorTextParts.push(options && `RequestOptions: ${JSON.stringify(options)}`);
        errorTextParts.push(response && `ResponseStatus: ${response.status}`);
        errorTextParts.push(exception && `Exception: ${JSON.stringify(exception)}`);

        var errorText = errorTextParts.filter(p => !!p).join(' ');

        throw new Error(errorText);
    }

    static _ignoreSensitiveData(options) {
        if(options.requestData) {
            options.requestData.password = '';
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/ws/ajax-call.js
 **/